import styled from 'styled-components';

type ContainerProps = {
  maxH?: string;
  useMaxH?: boolean;
};

const Container = styled.div<ContainerProps>`
  margin: 0 auto;
  width: 100%;
  overflow: auto;
  height: ${({ maxH, useMaxH }) => (useMaxH ? 'auto' : maxH || '400px')};
  max-height: ${({ useMaxH }) => (useMaxH ? '600px' : 'auto')};
  position: relative;
  border-radius: 4px;
  border: 1px solid #e0e0e0;

  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 transparent;

  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e0;
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #a0aec0;
  }
`;

const TableContainer = ({
  children,
  maxH,
  useMaxH,
}: {
  children: React.ReactNode;
  maxH?: string;
  useMaxH?: boolean;
}) => {
  return (
    <Container maxH={maxH} useMaxH={useMaxH}>
      {children}
    </Container>
  );
};

export default TableContainer;
